module.exports = __webpack_public_path__ + "img/9045d1091508caf7ad63e68ab0387e48.svg";